export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5927.4c347694.jpg";